module.exports = __webpack_public_path__ + "static/media/Event-Carousels-Wellness.00d71cdc.webp";